import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, vModelRadio as _vModelRadio, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "satisfaction-enquete" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = {
  key: 0,
  class: "step-bar-container"
}
const _hoisted_4 = {
  key: 0,
  class: "separator"
}
const _hoisted_5 = { class: "question" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "nb-char"
}
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = {
  key: 4,
  class: "nb-char"
}
const _hoisted_10 = { class: "checkbox-option" }
const _hoisted_11 = {
  key: 1,
  class: "checkbox-group"
}
const _hoisted_12 = ["id", "checked", "disabled", "value", "onChange"]
const _hoisted_13 = ["for"]
const _hoisted_14 = ["placeholder"]
const _hoisted_15 = {
  key: 1,
  class: "char-count"
}
const _hoisted_16 = {
  key: 2,
  class: "checkbox-group"
}
const _hoisted_17 = ["id", "checked", "disabled", "value", "onChange"]
const _hoisted_18 = ["for"]
const _hoisted_19 = ["placeholder"]
const _hoisted_20 = {
  key: 1,
  class: "char-count"
}
const _hoisted_21 = {
  key: 5,
  class: "radio"
}
const _hoisted_22 = ["id", "value"]
const _hoisted_23 = ["for"]
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "vertical-list" }
const _hoisted_27 = {
  key: 0,
  class: "solid"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_Step = _resolveComponent("Step")!
  const _component_ChoixSiteSatisfaction = _resolveComponent("ChoixSiteSatisfaction")!
  const _component_BottomNavigation = _resolveComponent("BottomNavigation")!
  const _component_WaitingModal = _resolveComponent("WaitingModal")!
  const _component_SuccessModal = _resolveComponent("SuccessModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", null, [
        _createTextVNode(_toDisplayString(_ctx.$t('satisfaction.questionnaire.title')) + " ", 1),
        _createVNode(_component_ReglePastille, { cle: "questionnaireSatisfaction.definition" })
      ])
    ]),
    (_ctx.steps.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.steps, (step, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "step-item"
            }, [
              _createVNode(_component_Step, {
                number: index + 1,
                state: _ctx.getStepState(index),
                title: step.label
              }, null, 8, ["number", "state", "title"]),
              (index < _ctx.steps.length - 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.questionData)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass([{
                expanded:
                    _ctx.questionType === 'TEXTAREA' ||
                    _ctx.questionType === 'CHECKBOX' ||
                    (_ctx.questionType === 'RADIO' && _ctx.radioOptions.length > 0),
            }, "question-container"])
        }, [
          _createElementVNode("div", _hoisted_5, [
            (_ctx.questionType !== 'CHOIX_SITE_RECLAMATION' || _ctx.showSiteSelection)
              ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.questionTitle), 1))
              : _createCommentVNode("", true),
            (_ctx.questionType === 'TEXTAREA' && _ctx.characterCount < _ctx.minCharacters)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                  _createTextVNode(_toDisplayString(_ctx.$t('satisfaction.questionnaire.nbcharmin.textarea')) + " " + _toDisplayString(_ctx.minCharacters) + " " + _toDisplayString(_ctx.$t('satisfaction.questionnaire.nbcharmax.textarea')) + ".", 1),
                  _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
                  _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1))
                ]))
              : _createCommentVNode("", true),
            (_ctx.questionType === 'TEXTAREA')
              ? (_openBlock(), _createBlock(_component_ReglePastille, {
                  key: 2,
                  cle: "questionnaireSatisfaction.limitesTexteLibre"
                }))
              : _createCommentVNode("", true),
            (_ctx.questionType === 'TEXTAREA')
              ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                  key: 3,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.response) = $event)),
                  placeholder: _ctx.$t('satisfaction.questionnaire.rep.textarea'),
                  onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updateCharacterCount && _ctx.updateCharacterCount(...args)))
                }, null, 40, _hoisted_8)), [
                  [_vModelText, _ctx.response]
                ])
              : _createCommentVNode("", true),
            (_ctx.questionType === 'TEXTAREA')
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.characterCount) + "/" + _toDisplayString(_ctx.maxCharacters) + " " + _toDisplayString(_ctx.$t('satisfaction.questionnaire.nbcharmax.textarea')), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_10, [
              (_ctx.questionType === 'CHECKBOX')
                ? (_openBlock(), _createBlock(_component_ReglePastille, {
                    key: 0,
                    cle: "questionnaireSatisfaction.optionAutre"
                  }))
                : _createCommentVNode("", true),
              (_ctx.questionType === 'CHECKBOX' && _ctx.options.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options1, (option, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "checkbox-option"
                      }, [
                        _createElementVNode("input", {
                          id: 'option-' + index,
                          checked: _ctx.isChecked(typeof option === 'object' ? option.id : option),
                          disabled: _ctx.isOptionDisabled(option),
                          value: typeof option === 'object' ? option.id : option,
                          type: "checkbox",
                          onChange: ($event: any) => (_ctx.toggleCheckbox(typeof option === 'object' ? option.id : option))
                        }, null, 40, _hoisted_12),
                        _createElementVNode("label", {
                          for: 'option-' + index
                        }, _toDisplayString(_ctx.libelleOption(option)), 9, _hoisted_13),
                        (typeof option === 'object' && option.isChampsLibre && _ctx.isChecked(option.id))
                          ? _withDirectives((_openBlock(), _createElementBlock("input", {
                              key: 0,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.otherValue) = $event)),
                              placeholder: _ctx.$t('satisfaction.questionnaire.rep.textautre'),
                              class: "other-input",
                              maxlength: "350",
                              type: "text",
                              onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.updateOtherValueCharCount && _ctx.updateOtherValueCharCount(...args)))
                            }, null, 40, _hoisted_14)), [
                              [_vModelText, _ctx.otherValue]
                            ])
                          : _createCommentVNode("", true),
                        (typeof option === 'object' && option.isChampsLibre && _ctx.isChecked(option.id))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.otherValueCharCount) + "/350 " + _toDisplayString(_ctx.$t('satisfaction.questionnaire.nbcharmax.textarea')), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.questionType === 'CHECKBOX' && _ctx.options.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options2, (option, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "checkbox-option"
                      }, [
                        _createElementVNode("input", {
                          id: 'option2-' + index,
                          checked: _ctx.isChecked(typeof option === 'object' ? option.id : option),
                          disabled: _ctx.isOptionDisabled(option),
                          value: typeof option === 'object' ? option.id : option,
                          type: "checkbox",
                          onChange: ($event: any) => (_ctx.toggleCheckbox(typeof option === 'object' ? option.id : option))
                        }, null, 40, _hoisted_17),
                        _createElementVNode("label", {
                          for: 'option2-' + index
                        }, _toDisplayString(_ctx.libelleOption(option)), 9, _hoisted_18),
                        (typeof option === 'object' && option.isChampsLibre && _ctx.isChecked(option.id))
                          ? _withDirectives((_openBlock(), _createElementBlock("input", {
                              key: 0,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.otherValue) = $event)),
                              placeholder: _ctx.$t('satisfaction.questionnaire.rep.textautre'),
                              class: "other-input",
                              maxlength: "350",
                              type: "text",
                              onInput: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.updateOtherValueCharCount && _ctx.updateOtherValueCharCount(...args)))
                            }, null, 40, _hoisted_19)), [
                              [_vModelText, _ctx.otherValue]
                            ])
                          : _createCommentVNode("", true),
                        (typeof option === 'object' && option.isChampsLibre && _ctx.isChecked(option.id))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.otherValueCharCount) + "/350 " + _toDisplayString(_ctx.$t('satisfaction.questionnaire.nbcharmax.textarea')), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.questionType === 'RADIO' && _ctx.radioOptions.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.radioOptions, (option, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "radio-option"
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        id: 'option-' + index,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.response) = $event)),
                        value: option.value,
                        type: "radio"
                      }, null, 8, _hoisted_22), [
                        [_vModelRadio, _ctx.response]
                      ]),
                      _createElementVNode("label", {
                        for: 'option-' + index
                      }, _toDisplayString(_ctx.libelleRadio(option)), 9, _hoisted_23)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.questionType === 'CHOIX_SITE_RECLAMATION')
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _createVNode(_component_ReglePastille, { cle: "questionnaireSatisfaction.noteInsatisfaitSites" }),
                (_ctx.showSiteSelection)
                  ? (_openBlock(), _createBlock(_component_ChoixSiteSatisfaction, {
                      key: 0,
                      isMultiSite: _ctx.isMultiSite,
                      selectedSite: _ctx.selectedSite,
                      selectedSites: _ctx.selectedSites,
                      class: "step-one-container",
                      onValider: _ctx.handleSiteSelection
                    }, null, 8, ["isMultiSite", "selectedSite", "selectedSites", "onValider"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _createElementVNode("h3", null, _toDisplayString(_ctx.$t('satisfaction.selected_sites_title')), 1),
                      _createElementVNode("ul", _hoisted_26, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedSites, (site) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: site.id,
                            class: "list-item"
                          }, _toDisplayString(site.description), 1))
                        }), 128))
                      ]),
                      (_ctx.isMultiSite && _ctx.selectedSites.length >= 1)
                        ? (_openBlock(), _createElementBlock("hr", _hoisted_27))
                        : _createCommentVNode("", true)
                    ]))
              ]))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    (!_ctx.withoutBotNav)
      ? (_openBlock(), _createBlock(_component_BottomNavigation, {
          key: 2,
          back: _ctx.currentStep > 1 ? _ctx.prevStep : null,
          cancel: _ctx.cancel,
          confirm: _ctx.nextStep,
          confirmButtonDisabled: !_ctx.activeValidate,
          first: _ctx.currentStep === 1,
          last: _ctx.currentStep === _ctx.questions.length,
          next: _ctx.nextStep
        }, null, 8, ["back", "cancel", "confirm", "confirmButtonDisabled", "first", "last", "next"]))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_WaitingModal, {
          key: 3,
          text: _ctx.$t('intervention.request.pending')
        }, null, 8, ["text"]))
      : _createCommentVNode("", true),
    (_ctx.isSubmitted)
      ? (_openBlock(), _createBlock(_component_SuccessModal, {
          key: 4,
          optionalImage: _ctx.optionalImagePath,
          subtitle: 
                _ctx.note === 1
                    ? _ctx.$t('satisfaction.questionnaire.remerciement.reclamation.message')
                    : _ctx.$t('satisfaction.questionnaire.remerciement.message')
            ,
          title: _ctx.$t('satisfaction.questionnaire.remerciement.title'),
          onCancel: _ctx.exit
        }, null, 8, ["optionalImage", "subtitle", "title", "onCancel"]))
      : _createCommentVNode("", true)
  ]))
}